import React, { useEffect, useState } from "react";
import NxtbnDrawer from "../drawer"
import useApi from "../../api";
import { toast } from "react-toastify";
import { InputField, NXForm } from "../common";
import { NXUser } from "../../icons";
import { handleRetriveError } from "../../utils";

export interface PropsTypes {
  id?: number;
  isOpen: boolean;
  onClose: ()=>void;
}

function CustomerEdit({ id, isOpen, onClose }: PropsTypes) {
  const [customer, setCustomer] = useState<any>(null)
  const [formData, setFormData] = useState<any>({})
  const [errorData, setErrorData] = useState<any>({});
  const [avatar, setAvatar] = useState<File>()
  const api = useApi()

  const fetchCustomer = () => {
    api.getCustomer(id).then((response:any)=>{
      setCustomer(response)
    }, handleRetriveError)
  }

  useEffect(()=>{
    fetchCustomer()
  }, [id])

  useEffect(()=>{
    setFormData(customer)
  }, [customer])

  const handleInputChange = (e:React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData((prev:any)=>({
      ...prev,
      [name]: value
    }))
  }

  const handleUpdateCustomer = (e:React.FormEvent<any>) => {
    e.preventDefault()
    const data = new FormData()
    data.append('first_name', formData.first_name)
    data.append('last_name', formData.last_name)
    data.append('email', formData.email)
    data.append('phone_number', formData.phone_number)
    
    if (avatar) data.append('avatar', avatar) 

    api.updateCustomer(id, data).then((response:any)=>{
      toast.success('Successfully updated customer info.')
      onClose()
    }).catch((error:any)=>{
      setErrorData(error.response.data)
      toast.error('Error update customer info.')
    })
  }

  return (
    <NxtbnDrawer size="md" title="Edit Customer" isOpen={isOpen} onClose={onClose}>
     <NXForm
        className="p-4"
        onSubmit={handleUpdateCustomer}
        title="Customer Information"
        nonFieldError={{}}
      >
        
        <div className="w-full flex justify-center my-4 cursor-pointer">
          <label htmlFor="avatar">
            { formData?.avatar || avatar ? 
              <img 
                src={avatar ? URL.createObjectURL(avatar) : formData?.avatar} 
                alt='' 
                className="border hover:bg-slate-500 aspect-square h-[150px] w-[150px] rounded-full object-cover"/>
              :
              <NXUser className="border hover:bg-base-200 aspect-square h-[150px] w-[150px] rounded-full object-cover"/>
            }
            </label>
          <InputField id="avatar" type="file" className="hidden" onChange={(e: React.ChangeEvent<HTMLInputElement>)=>{ e.target.files ? setAvatar(e.target.files[0]) : toast.warn('No file selected.') }}/>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          
          <div>
            <label className="block text-sm font-medium text-gray-700">First Name</label>
            <InputField
              type="text"
              name="first_name"
              placeholder="First Name"
              value={formData?.first_name || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Last Name</label>
            <InputField
              type="text"
              name="last_name"
              placeholder="Last Name"
              value={formData?.last_name || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <InputField
              type="email"
              name="email"
              placeholder="Email"
              value={formData?.email || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Phone Number</label>
            <InputField
              type="text"
              name="phone_number"
              placeholder="Phone Number"
              value={formData?.phone_number || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
        </div>
        <div className="flex justify-end mt-4">
          <button
            type="submit"
            className="px-4 py-2 bg-black text-white rounded">
            Update Customer
          </button>
        </div>
      </NXForm>
    </NxtbnDrawer>
  )
}

export default CustomerEdit